import React from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import PrivateRoute from './auth/PrivateRoute';
import AdminRoute from './auth/AdminRoute';
import Home from './main/Home';
import Page404 from './main/404/Page404';
import Signin from './auth/Signin';
import Signup from './auth/Signup';
import UserDashboard from './user/UserDashboard';
import AdminDashboard from './user/AdminDashboard';
import AddCategory from './admin/AddCategory';
import AddProduct from './admin/AddProduct';
import CreatePost from './admin/CreatePost';
import Detail from './main/ListProduct/Detail/Detail';
import Cart from './main/Cart/Cart';
import Checkout from './main/Checkout/Checkout';
import ListProBySort from './main/ListProduct/ListProBySort';
import UpdateProfile from './admin/UpdateProfile';

function App(props) {
    return (
        <BrowserRouter>
        {/* route here expose every page */}
        <Switch>
            <Route exact path='/' component={Home}/>
            <Route exact path='/signin' component={Signin}/>
            <Route exact path='/signup' component={Signup}/>
            <PrivateRoute exact path="/user/dashboard" component={UserDashboard}/>
            <AdminRoute exact path="/admin/dashboard" component={AdminDashboard}/>
            <AdminRoute exact path="/category/create" component={AddCategory}/>
            <AdminRoute exact path="/product/create" component={AddProduct}/>
            <Route exact path='/product/:productId' component={Detail}/>
            <Route exact path='/cart' component={Cart}/>
            <PrivateRoute exact path="/checkout" component={Checkout}/>
            <Route exact path='/category/:cateId' component={ListProBySort}/>
            <PrivateRoute exact path="/post/create/:userId" component={CreatePost}/>
            <PrivateRoute exact path="/profile/update/:userId" component={UpdateProfile}/>
            <Route component={Page404}/>
        </Switch>
        </BrowserRouter>
    );
}

export default App;